import React, { useEffect } from 'react';

export const InstructionPDF: React.FC = () => {
  useEffect(() => {
    const pdfUrl = '/WMP_2025-04-30_Handbuch.pdf';

    window.open(pdfUrl, '_blank');

    window.location.href = '/';
  }, []);

  return null;
};
